import { WithT } from 'i18next';

export function mapInfoTitles<T>(titles: Array<keyof T>, t: WithT['t']) {
	return titles.map((title) => ({
		key: title,
		title: t(title as string),
	}));
}
